var __templateData = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;
;var locals_for_with = (locals || {});(function (continueBtnText, doneText, game, hasNarration, hasPrompt, i18n, prompt, ratio, submitUp, title, undefined) {
if ( game && game.timer && game.timer.limit > 0 && !game.timer.isDisabled)
{
buf.push("<div class=\"full-screen\"><div class=\"game-stepper text-lg text-bold\"></div><div class=\"game-progress\"><div class=\"game-progress-bar\"></div></div></div>");
}
buf.push("<div class=\"content-fill\"><div class=\"content-fit block-v-xl content-lg-fill content-md-ver content-sm-ver\"><div class=\"row content-md-fill\"><div class=\"col-lg-6 col-sm-12 content-lg-ver block-v-sm\"><h1 class=\"text-lg-right text-md-center text-sm-center fade-in\">" + (null == (jade_interp = title) ? "" : jade_interp) + "</h1></div><div class=\"col-lg-6 col-sm-12 content-lg-ver\">");
// iterate ratio.bars
;(function(){
  var $$obj = ratio.bars;
  if ('number' == typeof $$obj.length) {

    for (var i = 0, $$l = $$obj.length; i < $$l; i++) {
      var bar = $$obj[i];

buf.push("<div" + (jade.cls(['text-lg','block-v-sm','slide-up',"delay-" + (i + 1) + ""], [null,null,null,true])) + "><div class=\"ratio-title pull-left block-v-sm\">" + (null == (jade_interp = bar.title) ? "" : jade_interp) + "</div><div" + (jade.attr("data-answer-id", i, true, false)) + " class=\"ratio\"><div class=\"ratio-bar-container block-dk\"><div class=\"ratio-bar\"></div></div><div class=\"ratio-value\"><div class=\"ratio-value-amount pull-right\">&hellip;</div></div></div></div>");
    }

  } else {
    var $$l = 0;
    for (var i in $$obj) {
      $$l++;      var bar = $$obj[i];

buf.push("<div" + (jade.cls(['text-lg','block-v-sm','slide-up',"delay-" + (i + 1) + ""], [null,null,null,true])) + "><div class=\"ratio-title pull-left block-v-sm\">" + (null == (jade_interp = bar.title) ? "" : jade_interp) + "</div><div" + (jade.attr("data-answer-id", i, true, false)) + " class=\"ratio\"><div class=\"ratio-bar-container block-dk\"><div class=\"ratio-bar\"></div></div><div class=\"ratio-value\"><div class=\"ratio-value-amount pull-right\">&hellip;</div></div></div></div>");
    }

  }
}).call(this);

buf.push("</div></div></div></div><div" + (jade.cls(['slide-footer','block-v-lg',submitUp ? "slide-footer--up slide-down" : "slide-up"], [null,null,true])) + ">");
if ( hasPrompt)
{
buf.push("<div class=\"slide-footer-touched\"><div class=\"btn btn-muted btn-done text-ellipsis\">" + (null == (jade_interp = doneText) ? "" : jade_interp) + "</div></div>");
if ( typeof prompt === "string")
{
buf.push("<div class=\"slide-footer-prompt text-uppercase text-bold\"><div class=\"slide-footer-prompt-content content-ver\">" + (null == (jade_interp = prompt) ? "" : jade_interp) + "</div></div>");
}
}
else
{
buf.push("<div class=\"slide-footer-prompt\"><div class=\"btn btn-muted btn-done text-ellipsis content-ver\">" + (null == (jade_interp = continueBtnText || i18n("buttons.continue")) ? "" : jade_interp) + "</div></div>");
}
if ( hasNarration)
{
buf.push("<div class=\"slide-footer-narration\"><div class=\"narration-progress btn btn-muted\"><div class=\"narration-progress-bar\"></div><div class=\"wave-ellipse\"><span class=\"bullet delay-1 block-inline\">&bullet;</span><span class=\"bullet delay-2 block-inline\">&bullet;</span><span class=\"bullet delay-3 block-inline\">&bullet;</span></div></div></div>");
}
buf.push("</div>");}.call(this,"continueBtnText" in locals_for_with?locals_for_with.continueBtnText:typeof continueBtnText!=="undefined"?continueBtnText:undefined,"doneText" in locals_for_with?locals_for_with.doneText:typeof doneText!=="undefined"?doneText:undefined,"game" in locals_for_with?locals_for_with.game:typeof game!=="undefined"?game:undefined,"hasNarration" in locals_for_with?locals_for_with.hasNarration:typeof hasNarration!=="undefined"?hasNarration:undefined,"hasPrompt" in locals_for_with?locals_for_with.hasPrompt:typeof hasPrompt!=="undefined"?hasPrompt:undefined,"i18n" in locals_for_with?locals_for_with.i18n:typeof i18n!=="undefined"?i18n:undefined,"prompt" in locals_for_with?locals_for_with.prompt:typeof prompt!=="undefined"?prompt:undefined,"ratio" in locals_for_with?locals_for_with.ratio:typeof ratio!=="undefined"?ratio:undefined,"submitUp" in locals_for_with?locals_for_with.submitUp:typeof submitUp!=="undefined"?submitUp:undefined,"title" in locals_for_with?locals_for_with.title:typeof title!=="undefined"?title:undefined,"undefined" in locals_for_with?locals_for_with.undefined:typeof undefined!=="undefined"?undefined:undefined));;return buf.join("");
};
if (typeof define === 'function' && define.amd) {
  define([], function() {
    return __templateData;
  });
} else if (typeof module === 'object' && module && module.exports) {
  module.exports = __templateData;
} else {
  __templateData;
}